const genericErrorCodes = {
  'generic-error-message': 'Ein unerwarteter Fehler ist aufgetreten'
};

export default genericErrorCodes;
